import { render } from "./templateForm.vue?vue&type=template&id=6964dd76"
import script from "./templateForm.vue?vue&type=script&lang=js"
export * from "./templateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__